'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import styles from './CarouselShowcaseSlide.module.scss';

const imageTransitionDuration = '8s';

const CarouselShowcaseSlide = ({
    eyebrow,
    richHeadline,
    image,
    imageLarge,
    className,
    isActive,
    isPrev,
}) => {
    const [transitionEnded, setTransitionEnded] = useState(false);

    const handleTransitionEnd = () => {
        setTransitionEnded(true);
    };

    useEffect(() => {
        setTransitionEnded(false);
    }, [isActive]);

    return (
        <article
            className={cx(styles.carouselShowcaseSlide, className, {
                [styles.isActive]: isActive,
                [styles.isPrev]: !transitionEnded && isPrev,
            })}
        >
            <div className={styles.column}>
                <div className={styles.imageWrapper}>
                    <div
                        className={styles.imageWrapperInner}
                        style={{
                            transitionDuration: imageTransitionDuration,
                        }}
                    >
                        {image?.url && imageLarge?.url && (
                            <Img
                                className={styles.image}
                                src={image.url}
                                fallbackImageWidth={297 * 2}
                                alt={image.description || ''}
                                width={image?.width}
                                height={image?.height}
                                customSources={[
                                    {
                                        breakpoint: 768,
                                        src: imageLarge.url,
                                        imageWidth: 912,
                                    },
                                    {
                                        src: image.url,
                                        imageWidth: 297 * 2,
                                    },
                                ]}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.column}>
                {richHeadline && (
                    <div className={styles.textLockup}>
                        <div className={styles.eyebrowLockup}>
                            {eyebrow && (
                                <div className={styles.eyebrowWrap}>
                                    <Text
                                        className={styles.eyebrow}
                                        baseTheme={'labelSmall'}
                                        themes={{ medium: 'labelLarge' }}
                                        as="h3"
                                    >
                                        {eyebrow}
                                    </Text>
                                </div>
                            )}
                            <Text
                                className={styles.headline}
                                as="h2"
                                baseTheme="displaySmall"
                                themes={{
                                    large: 'displayMedium',
                                    xxLarge: 'displayLargeFluid',
                                }}
                            >
                                {richHeadline?.json?.content.map((line, i) => {
                                    if (line.content[0].value === '') {
                                        return null;
                                    }
                                    return (
                                        <span
                                            key={i}
                                            className={styles.headlineLineWrap}
                                            onTransitionEnd={
                                                isPrev
                                                    ? handleTransitionEnd
                                                    : null
                                            }
                                        >
                                            <span
                                                className={styles.headlineLine}
                                            >
                                                {line.content[0].value}
                                            </span>
                                        </span>
                                    );
                                })}
                            </Text>
                        </div>
                    </div>
                )}
            </div>
        </article>
    );
};

CarouselShowcaseSlide.propTypes = {
    eyebrow: PropTypes.string,
    richHeadline: PropTypes.object.isRequired,
    image: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    imageLarge: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    className: PropTypes.string,
    isActive: PropTypes.bool,
    isPrev: PropTypes.bool,
};

export default CarouselShowcaseSlide;
